/**
 * Allowlisted fields for copy / display — mirrors API Ops::ErrorDiagnostics::ALLOWLIST.
 * Never copy Authorization, bodies, tokens, or PII.
 */
export const DIAGNOSTICS_COPY_ALLOWLIST = Object.freeze([
  "request_id",
  "recorded_at",
  "http_status",
  "http_method",
  "route",
  "error_class",
  "code",
  "kind",
  "operation_key",
  "outcome",
  "company_id",
  "release",
  "job_id",
  "integration_ref",
  "ops_incident_path",
]);

const SENSITIVE_KEY_RE =
  /authorization|cookie|password|secret|token|national|personnummer|ssn|fnr|body|stack|backtrace/i;

/**
 * @param {unknown} data
 * @returns {Record<string, string|number>|null}
 */
export function sanitizeDiagnosticsForUi(data) {
  if (!data || typeof data !== "object") return null;
  const out = {};
  DIAGNOSTICS_COPY_ALLOWLIST.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(data, key) && data[key] != null) {
      if (SENSITIVE_KEY_RE.test(key)) return;
      const v = data[key];
      if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") {
        out[key] = v;
      } else {
        out[key] = String(v).slice(0, 200);
      }
    }
  });
  return Object.keys(out).length ? out : null;
}

/**
 * Plain-text clipboard payload (allowlisted only).
 * @param {unknown} data
 * @param {{ safeMessage?: string, requestId?: string }} [publicContext]
 */
export function formatDiagnosticsCopyText(data, publicContext = {}) {
  const lines = [];
  if (publicContext.safeMessage) {
    lines.push(`message: ${publicContext.safeMessage}`);
  }
  const sanitized = sanitizeDiagnosticsForUi(data) || {};
  if (publicContext.requestId && !sanitized.request_id) {
    lines.push(`request_id: ${publicContext.requestId}`);
  }
  DIAGNOSTICS_COPY_ALLOWLIST.forEach((key) => {
    if (sanitized[key] != null && sanitized[key] !== "") {
      lines.push(`${key}: ${sanitized[key]}`);
    }
  });
  return lines.join("\n");
}
